import { NavigateOptions, useNavigate } from 'react-router';
import { createSearchParams, URLSearchParamsInit } from 'react-router-dom';

export function useNavigateWithSearch() {
  const navigate = useNavigate();

  return (pathname: string, params?: Record<string, string> | URLSearchParamsInit, options?: NavigateOptions) =>
    navigate({ pathname, search: params && `?${createSearchParams(params)}` }, options);
}
